export default __webpack_public_path__ + "static/media/slice-background-bar.1e0c6b9c.jpg";